export default "__VITE_ASSET__27ed32e8__"